// TopAlertsCard.js
import { Box, Paper, Stack } from "@mui/material";
import Chip from "@mui/material/Chip";
import React from "react";
import { useNavigate } from "react-router-dom";
import CardHeaderTitle from "../../components/card-header-title/index.jsx";
import { removeDetectKeywordFromVisuals } from "../../helpers/index.js";

const TopAlertsCard = ({ data, colours }) => {
  const navigate = useNavigate();

  return (
    <Paper
      sx={{ display: "flex", flexDirection: "column", width: { xs: '100%', sm: '50%' }, borderRadius: 2.5, padding: 3, boxSizing: "border-box" }}
    >
      <CardHeaderTitle
        title="Top Alerts"
        tooltip="The Alerts most frequently triggered."
        viewDetailTitle="View Details"
        viewDetailAction={() => navigate("/alerts")}
      />

      <Box marginTop={2}>
        <Stack direction="row" flexWrap="wrap" gap={1}>
          {!data.alerthits
            ? null
            : data.alerthits.map((z, zx) => (
              <Chip
                label={removeDetectKeywordFromVisuals(z.alert)}
                key={zx}
                size="small"
              />
            ))}
        </Stack>
      </Box>
    </Paper>
  );
};

export default TopAlertsCard;